/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EFileViewerMode } from "../types/EFileViewerMode.ts";

/**
 * @description 0 = NoAttachment | 1 = Pdf | 2 = NonPdf |
 */
export const eFileViewerModeSchema = z
  .union([z.literal(0), z.literal(1), z.literal(2)])
  .describe(
    "0 = NoAttachment | 1 = Pdf | 2 = NonPdf | ",
  ) as unknown as ToZod<EFileViewerMode>;
